import { Media } from "@omni/types/api/shared/bff/media.model";
import { isDefined } from "@omni/utils/helper.utils";
import { isEmpty } from "lodash-es";
import {
    Dispatch,
    ReactNode,
    SetStateAction,
    useEffect,
    useState
} from "react";
import SwiperCore from "swiper";

import { ImageGalleryContextProvider } from "@/components/ImageGallery/context/imageGallery.context";

type Props = {
    images: Array<Media>;
    activeIndexState?: [number, Dispatch<SetStateAction<number>>];
    className?: string;
    children?: ReactNode;
};

export const Base = ({
    images,
    activeIndexState: propsActiveIndexState,
    className,
    children
}: Props) => {
    const magagedActiveIndexState = useState<number>(0);

    const [mainSwiper, setMainSwiper] = useState<SwiperCore>();
    const [thumbSwiper, setThumbSwiper] = useState<SwiperCore>();

    const [activeIndex, setActiveIndex] = isDefined(propsActiveIndexState)
        ? propsActiveIndexState
        : magagedActiveIndexState;

    const setActiveIndexSafe = (action: (prev: number) => number) => {
        return setActiveIndex((prev) => {
            const newState = action(prev);

            return newState >= 0 && newState < images.length ? newState : prev;
        });
    };

    const next = () => {
        setActiveIndexSafe((prev) => prev + 1);
    };

    const previous = () => {
        setActiveIndexSafe((prev) => prev - 1);
    };

    useEffect(() => {
        if (mainSwiper?.activeIndex !== activeIndex) {
            mainSwiper?.slideTo(activeIndex);
        }

        if (thumbSwiper?.activeIndex !== activeIndex) {
            thumbSwiper?.slideTo(activeIndex);
        }
    }, [activeIndex, mainSwiper, thumbSwiper]);

    if (isEmpty(images)) return null;

    return (
        <ImageGalleryContextProvider
            images={images}
            activeIndex={activeIndex}
            mainSwiper={mainSwiper}
            thumbSwiper={thumbSwiper}
            setActiveIndex={setActiveIndexSafe}
            next={next}
            previous={previous}
            setMainSwiper={setMainSwiper}
            setThumbSwiper={setThumbSwiper}
        >
            <div className={className}>{children}</div>
        </ImageGalleryContextProvider>
    );
};
